import http from "./http";

export type StationRequestEmailConfig = {
	recipientEmails: string;
	adminNotificationRecipients: string;
	updatedAt?: string;
};

const DEFAULTS: StationRequestEmailConfig = {
	recipientEmails: "",
	adminNotificationRecipients: "info@whalelo.net",
};

export async function getStationRequestEmailConfig(): Promise<StationRequestEmailConfig> {
	const { data } = await http.get("/utility/station-request-email-config");
	return { ...DEFAULTS, ...(data?.data || {}) };
}

export async function saveStationRequestEmailConfig(config: StationRequestEmailConfig) {
	const { data } = await http.post("/utility/station-request-email-config", { data: config });
	return data;
}
